import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.sass']
})
export class ContactComponent {

  applicayionId!: number;

  constructor(
    private messageService: MessageService) { 
      this.applicayionId = environment.applicayionId;
    }


  onContactSend(send: any) {
    if (send) {
      this.messageService.add({ key: 'tc', severity: 'info', summary: 'Mensaje enviado exitosamente', detail: 'Su mensaje se ha enviado pronto nos pondremos en contacto.' });
    } else {
      this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: 'No hemos podido procesar su solicitd' });
    }
  }
}
